import { generateClient } from "aws-amplify/api";

const client = generateClient();

import { list_lab_masters } from '@/graphql/queries'

export default {
    data() {
        return {
            labsList: [],
        }
    },
    methods: {
        async fetchLabsList() {
            try {
                const response = await client.graphql({
                    query: list_lab_masters,
                    variables: {
                        input: {
                            lab_status: 'ACTIVE',
                            source: "BMS",
                        }
                    }
                })
                let responseData = JSON.parse(response.data.list_lab_masters)
                // console.log(responseData)
                if (responseData.status == "SUCCESS") {
                    this.labsList = responseData.data || []
                } else {
                    this.labsList = []
                }
                // console.log(this.labsList)
            } catch (error) {
                console.error("Error fetching Labs List:", error);
                this.labsList = [];
                throw error;
            }
        },
    },
};
